import { Helmet } from 'react-helmet';
import { ReactElement, useRef, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { allFramesInitialized } from './host';
import { IAddress, IError, LoadingOverlay, useToast } from '@comptia-sso/core';
import { useSierra } from '../../app/SierraContext';
import { AddressVerificationModal } from '../../components/AddressVerification/AddressVerificationModal';
import { useProfile } from '../../hooks';

export const SierraView = (): ReactElement => {
  const { t } = useTranslation();
  const [initialized, setInitialized] = useState(false);
  const sierra = useSierra();
  const [isVerifying, setIsVerifying] = useState<boolean>(false);
  const [popToast] = useToast();
  const [profile] = useProfile();

  const commandCallback = useCallback((cmd: any) => {
    switch (cmd.command) {
      case 'UPDATE_ADDRESS':
        setIsVerifying(true);
        break;
    }
  }, []);

  useEffect(() => {
    sierra.registerCommandCallback(commandCallback);
    return () => sierra.unRegisterCommandCallback(commandCallback);
  }, [commandCallback]);

  function checkLoaded() {
    const newInitialized = allFramesInitialized();
    console.log('check initialized: ' + newInitialized);
    setInitialized(newInitialized);
    if (!newInitialized) setTimeout(checkLoaded, 500);
  }

  useEffect(() => {
    checkLoaded();
  }, []);

  const handleClose = useCallback(() => {
    setIsVerifying(false);
  }, []);

  const handleSubmit = useCallback(async (values: Partial<IAddress>) => {
    try {
      sierra.sendCustomCommand('ADDRESS', values);
      handleClose();
    } catch (error) {
      popToast((error as IError)?.message || t('Toast.Error.Default'));
    }
  }, []);

  return (
    <>
      <Helmet titleTemplate="%s | CompTIA">
        <title>{sierra.getCurrentRouteTitle()}</title>
      </Helmet>
      <div>
        <AddressVerificationModal
          onClose={handleClose}
          onSubmit={handleSubmit}
          open={isVerifying}
          profile={profile}
        />
        <LoadingOverlay
          animateOnEnter={false}
          isOpen={!initialized}
          text={t('Loading.Default')}
        />
      </div>
    </>
  );
};
